export default "__VITE_ASSET__5fdee8a0__"